const styleConfigs = {
  classNames: {
    Filter: "d-none",
    SettingsToggle: "d-none",
    Cell: "griddle-cell",
    Row: "griddle-row bgc-h-yellow-l4 d-style",
    RowDefinition: "griddle-row-definition",
    Table:
      "mb-0 table table-borderless table-bordered-x brc-secondary-l3 text-dark-m2 radius-1 overflow-hidden",
    TableBody: "griddle-table-body ",
    TableHeading:
      "text-primary text-dark-tp3 bgc-grey-l4 text-90 border-b-1 brc-transparent",
    TableHeadingCell: "griddle-table-heading-cell",
    Pagination:
      "griddle-pagination d-flex pl-4 pr-3 pt-35 pb-35 border-t-1 brc-secondary-l3 flex-column flex-sm-row mt-n1px",
    NextButton:
      "griddle-next-button btn btn-lighter-default btn-bgc-white btn-a-secondary radius-r-1 px-3 border-2 ml-n2px",
    PreviousButton:
      "griddle-previous-button btn btn-lighter-default btn-bgc-white btn-a-secondary radius-l-1 px-3 border-2",
    PageDropdown:
      "griddle-page-select ace-select no-border angle-down brc-h-blue-m3 w-auto pr-45 text-secondary-d3",
  },
  styles: {},
};

export default styleConfigs;
